import n from 'vscode/external/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = "div.share-dialog-input-link,div.share-dialog-input-text{background-color:var(--vscode-input-background);border:1px solid var(--vscode-input-border,transparent);border-radius:2px;color:var(--vscode-input-foreground);line-height:24px;padding:2px;user-select:all}div.share-dialog-input-link{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";
n(css,{});

export { css, css as default };
